<template>
    <button type="button" @click="$emit('click')"
            class="mr-6 inline-flex items-center px-4 py-2 space-x-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400">
        <div class="items-center">
            <slot name="icon"></slot>
            <slot>BUTTON TEXT</slot>
        </div>
    </button>
</template>

<script>
export default {
    name: "ButtonPrimary"
}
</script>

<style scoped>

</style>
